<template>
  <div>
    <blockquote v-if="task.description">
      {{ task.description }}
    </blockquote>
    <p v-if="task.textHint">{{ task.textHint }}</p>
    <form-generator
      v-if="task.taskType === 'form'"
      @onAnswer="generatorSubmit"
      :value="task.data"
    >
    </form-generator>
    <quiz-generator
      v-else-if="task.taskType === 'quiz'"
      @onAnswer="generatorSubmit"
      :value="task.data"
    >
    </quiz-generator>
    <form-task-answer-upload
      v-else-if="task.taskType === 'upload'"
      @onAnswer="formSubmit"
    >
    </form-task-answer-upload>
    <form-task-answer-text
      v-else-if="task.taskType === 'answer'"
      @onAnswer="formSubmit">
    </form-task-answer-text>

  </div>
</template>


<script>
  import {createNamespacedHelpers} from 'vuex';
  import {TaskAnswerForm} from "../../../mixins/Student/TaskAnswerForm";
  import {FormNotification, FormSubmitHandlers} from "../../../mixins/FormApiHandlers";
  import FormGenerator from "../../../components/FormGenerator/FormGenerator";
  import QuizGenerator from "../../../components/QuizGenerator/QuizGenerator";
  import FormTaskAnswerUpload from "./FormTaskAnswerUpload";
  import FormTaskAnswerText from "./FormTaskAnswerText";

  const {mapActions, mapState} = createNamespacedHelpers('student/task/answer');

  export default {
    name: "FormCreateAnswerTask",
    components: {FormTaskAnswerText, FormTaskAnswerUpload, FormGenerator, QuizGenerator},
    props: {
      task: Object,
      redirect: Object,
    },
    data() {
      return {
        status: 0,
        successMessage: this.$i18n.t('You are send task answer!'),
        errorMessage: this.$i18n.t('Error on sending task answer!'),
        submitRedirectTo: {name: 'learn-course-page', params: this.$route.params},
      }
    },
    mixins: [TaskAnswerForm, FormNotification, FormSubmitHandlers],
    computed: {
      ...mapState({
        vuexStatus: state => state.createStatus
      })
    },
    mounted() {
      this.submitRedirectTo = this.redirect
    },
    watch: {
      'vuexStatus': function(val) {
        if (val.id === this.task.id) {
          this.status = val.status
        }
      }
    },
    methods: {
      ...mapActions({
        createAnswer: 'createAnswer',
      }),
      revertStatus() {
        this.status = 0;
      },
      generatorSubmit(val) {
        this.formSubmit({payload: val});
      },
      async formSubmit(formData) {
        await this.createAnswer({
          urlParams: {...this.$route.params, taskId: this.task.id},
          form: {
            ...formData
          }
        });
        this.$emit('onSend')
      }
    }
  }
</script>

<style scoped lang="scss">
  .switch-with-label {
    label {
      vertical-align: text-top;
      margin-right: 0.5rem;
    }

  }
</style>
